import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface CaseAccessEntry {
  case_id: number
  case_name: string
  employees: string[]
}

interface Props {
  allow_list: CaseAccessEntry[]
  block_list: CaseAccessEntry[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Employees", href: "/employees" },
  { title: "Access Exceptions", href: "/employees/reports/access-exceptions" },
]

export default function AccessExceptions({ allow_list, block_list }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Case Access Exceptions" />

      <div className="p-6">
        <h2 className="mb-4 text-xl font-semibold">Case Access Exceptions</h2>

        {allow_list.length > 0 && (
          <section className="mb-8">
            <h3 className="mb-3 text-lg font-semibold">
              Limited Access Employees with access to Open Cases
            </h3>
            <ul className="space-y-3">
              {allow_list.map((entry) => (
                <li key={entry.case_id}>
                  <Link
                    href={`/cases/${entry.case_id}`}
                    className="font-bold text-blue-700 hover:underline"
                  >
                    {entry.case_name}
                  </Link>
                  <ul className="mt-1 ml-6 list-disc text-sm text-gray-700">
                    {entry.employees.map((emp) => (
                      <li key={emp}>{emp}</li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </section>
        )}

        {block_list.length > 0 && (
          <section className="mb-8">
            <h3 className="mb-3 text-lg font-semibold">
              Full Access Employees Blocked from Case Access
            </h3>
            <ul className="space-y-3">
              {block_list.map((entry) => (
                <li key={entry.case_id}>
                  <Link
                    href={`/cases/${entry.case_id}`}
                    className="font-bold text-blue-700 hover:underline"
                  >
                    {entry.case_name}
                  </Link>
                  <ul className="mt-1 ml-6 list-disc text-sm text-gray-700">
                    {entry.employees.map((emp) => (
                      <li key={emp}>{emp}</li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </section>
        )}

        {allow_list.length === 0 && block_list.length === 0 && (
          <div className="text-sm text-gray-500">No exceptions found.</div>
        )}
      </div>
    </AppLayout>
  )
}
